// only use response === true as the first step for now
export default {
  actions: {
    getGoogleInfo: {
      next: [
        {
          condition: "response === true",
          action: "isGoogleAdmin"
        },
        {
          view: "/google/error"
        }
      ]
    },
    isGoogleAdmin: {
      next: [
        {
          action: "isCurrentCustomer"
        }
      ]
    },
    checkNoAuth: {
      next: [
        {
          condition: "response === true",
          view: "/create-account"
        },
        {
          view: "/no-auth"
        }
      ]
    },
    isCurrentCustomer: {
      next: [
        {
          condition: "state.isGoogleAdmin.response === true && response === true",
          action: "isProductEnabled"
        },
        {
          condition: "state.isGoogleAdmin.response === true && response === false",
          view: "/create-account"
        },
        {
          condition: "state.isGoogleAdmin.response === false && response === true",
          action: "hasProductAccess"
        },
        {
          action: "errorBadEmail"
        }
      ]
    },
    isProductEnabled: {
      next: [
        {
          condition: "response === true",
          action: "hasProductAccess"
        },
        {
          action: "isSuperAdmin"
        }
      ]
    },
    hasProductAccess: {
      next: [
        {
          condition: "response === true",
          view: "/login"
        },
        {
          condition: "state.isGoogleAdmin.response === true && response === false",
          action: "isSuperAdmin"
        },
        {
          action: "errorBadEmail"
        }
      ]
    },
    contactAdmin: {
      next: [
        {
          view: "/thank-you"
        }
      ]
    },
    isSuperAdmin: {
      next: [
        {
          condition: "state.isProductEnabled.response === true && response === true",
          action: "grantProductAccess"
        },
        {
          condition: "state.isProductEnabled.response === false && response === true",
          view: "/products"
        },
        {
          action: "contactAdmin"
        }
      ]
    },
    createAccount: {
      next: [
        {
          condition: "response === true",
          view: "/products"
        },
        {
          view: "/create-account"
        }
      ]
    },
    grantProductAccess: {
      next: [
        {
          view: "/login"
        }
      ]
    },
    enableProducts: {
      next: [
        { // If sales is signing up an org, then we skip the survey and getting started flow
          condition: "state.noSalesEmail === true",
          view: "/getting-started/end"
        },
        {
          view: "/survey/start"
        }
      ]
    },
    errorBadEmail: {
      next: [
        {
          condition: "state.isCurrentCustomer.response === true",
          action: "contactAdmin"
        },
        {
          view: "/admin-email"
        }
      ]
    },
    submitSurvey: {
      next: [
        {
          condition: "state.enableProducts.isExtensionPushed === true || (state.enableProducts.products.length === 1 && state.enableProducts.products[0] === 3)",
          view: "/getting-started/end"
        },
        {
          view: "/getting-started/begin"
        }
      ]
    }
  }
};



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/